export default __webpack_public_path__ + "static/purple-cards-9cb395a43c96772dd680807015072db6.png";